export default __webpack_public_path__ + "static/media/36I-114278_-20465_0.3f8c8c33.jpg";